import withSharedStyles from "../../theme/Shared.style";

const withCustomStyles = withSharedStyles(theme => {
  const { color, radius, fontSize } = theme.tokens;

  return {
    badge: {
      display: "inline-flex",
      alignItems: "center",
      gap: 4,
      alignSelf: "flex-start",
      padding: "3px 8px",
      borderRadius: radius.badge,
      fontSize: fontSize.micro,
      fontWeight: 700,
      lineHeight: 1.4,
      whiteSpace: "nowrap"
    },
    status: {
      display: "inline-flex",
      alignItems: "center",
      gap: 6,
      height: 28,
      padding: "0 10px",
      borderRadius: radius.pill,
      fontSize: fontSize.small,
      fontWeight: 700,
      whiteSpace: "nowrap"
    },
    dot: {
      width: 8,
      height: 8,
      borderRadius: radius.pill,
      backgroundColor: "currentColor"
    },
    deal: { backgroundColor: color.deal, color: color.bg },
    brand: { backgroundColor: color.brandTint, color: color.brandText },
    success: { backgroundColor: color.successTint, color: color.success },
    neutral: { backgroundColor: color.field, color: color.text2 },
    danger: { backgroundColor: color.dangerTint, color: color.danger }
  };
});

export default withCustomStyles;
